import styled from 'styled-components'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { ActionButton as $ActionButton } from '../../widget.styles'

export const Box = styled.div<{
  display?: string
  flexDirection?: string
  gap?: string
  justifyContent?: string
  alignItems?: string
  padding?: string
  directionOnMobile?: string
}>`
  display: ${props => props.display || 'flex'};
  flex-direction: ${props => props.flexDirection || 'row'};
  gap: ${props => props.gap || '0'};
  ${props => props.justifyContent && `justify-content: ${props.justifyContent};`};
  ${props => props.alignItems && `align-items: ${props.alignItems};`};
  padding: ${props => props.padding || '0'};
  flex: 1;
  overflow: hidden;
  height: auto;
  & img {
    max-width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  ${props => Media.Phone` flex-direction: ${props.directionOnMobile ?? props.flexDirection};`}
`

export const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  border: none;
  cursor: pointer;
`

export const ActionText = styled.span`
  ${Typography.Body};
  ${FontWeights.Regular};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ActionButton = styled($ActionButton)`
  ${Media.Phone` width: 100%; span { justify-content: center; } `};

  & svg {
    ${Media.Phone` display: none; `};
  }
`
